export default {
  list: '/notifications/',
  tabHash: ['user'],
}
